export default __webpack_public_path__ + "static/media/users.ec43e952.svg";